import { render, staticRenderFns } from "./serviceOrdeItem.vue?vue&type=template&id=a8060fa6&scoped=true&"
import script from "./serviceOrdeItem.vue?vue&type=script&lang=ts&"
export * from "./serviceOrdeItem.vue?vue&type=script&lang=ts&"
import style0 from "./serviceOrdeItem.vue?vue&type=style&index=0&id=a8060fa6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8060fa6",
  null
  
)

export default component.exports